import gql from 'graphql-tag';

export default gql`
  mutation setActiveAdminUser($id: Int!, $active: Boolean!) {
    setActiveAdminUser(id: $id, active: $active)
  }
`;
